module.exports = __webpack_public_path__ + "static/media/pycharm.63c8f9a5.svg";